import { FC } from 'react';
import type { DentalXChangeDentalSummaryInfo } from '@frontend/api-insurance-eligibility-report';
import { ActiveCoverageTable } from './ActiveCoverageTable';
import { BenefitDescriptionTable } from './BenefitDescriptionTable';
import { CoInsuranceTable } from './CoInsuranceTable';
import { CoPaymentTable } from './CoPaymentTable';
import { DeductibleTable } from './DeductibaleTable';
import { ExclusionsTable } from './ExclusionsTable';
import { LimitationsTable } from './LimitationsTable';
import { MaximumsTable } from './MaximumsTable';
import { NotCoveredTable } from './NotCoveredTable';
import { OtherBenefitTable } from './OtherBenefitTable';
import { OtherPayerTable } from './OtherPayor';
import { OtherSourceOfDataTable } from './OtherSourceOfDataTable';
import { OutOfPocketTable } from './OutofPocketTable';

type GetInsuranceTableComponentParamTypes = {
  tableId: keyof DentalXChangeDentalSummaryInfo;
};

type InsuranceTableComponentsType = {
  [key in keyof DentalXChangeDentalSummaryInfo]: FC;
};

const insuranceTableComponents: InsuranceTableComponentsType = {
  activeCoverage: ActiveCoverageTable,
  coInsurance: CoInsuranceTable,
  coPayment: CoPaymentTable,
  deductible: DeductibleTable,
  benefitDescription: BenefitDescriptionTable,
  exclusions: ExclusionsTable,
  limitation: LimitationsTable,
  maximum: MaximumsTable,
  notCovered: NotCoveredTable,
  otherPayor: OtherPayerTable,
  otherBenefit: OtherBenefitTable,
  outOfPocket: OutOfPocketTable,
  otherSourceOfData: OtherSourceOfDataTable,
};

export const getInsuranceTableComponent = ({ tableId }: GetInsuranceTableComponentParamTypes): FC | null => {
  return insuranceTableComponents[tableId] || null;
};
